<template>
  <span
    class="el-status-tag"
    :class="statusClass"
  >
    {{ label }}
  </span>
</template>

<script>
const labelNames = {
	출석: "attend",
	지각: "late",
	결석: "absense",
	예약: "booked",
	연강: "continuous",
	대기: 'waiting',
};

export default {
	name: "ElStatusTag",
	props: ["label"],
	computed: {
		statusClass() {
			if (labelNames[this.label]) {
				return [labelNames[this.label]];
			}
		},
	},
};
</script>

<style lang="scss">
.el-status-tag {
	font-size: 11px;
	font-weight: 300;
	letter-spacing: -0.5px;
	text-align: center;
	color: #ffffff;
	height: 19px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	border-radius: 11.5px;
	padding: 0 7px;
	line-height: 19px;
	display: inline-block;
	background-color: #224ba2;

	&.attend {
		background-color: #4a4a4a;
	}

	&.late {
		background-color: #ffd90a;
	}

	&.absense {
		background-color: #dc1e00;
	}

	&.booked {
		background-color: #9b9b9b;
	}

	&.continuous {
		background-color: #b9b9b9;
	}

	&.waiting {
		background-color: #d3d3d3;
	}
}
</style>
